import React, { useEffect, useState } from "react";
import { Button, Input, Select, Space, Table, Tooltip, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  ajouterRapportEmettre,
  getStrategieGlobaleMission,
} from "../../../../../../data/stategieGlobale";
import swal from "sweetalert";
import { succesMessage } from "../../../../../../helpers/AssetsHelpers";
import { getListeMembreMission } from "../../../../../../data/exercice";
import TableTitle from "../../../../../common/TableTitle";
import { appTheme } from "../../../../../../config/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileImport,
  faSave,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

const { Title } = Typography;

const Rapport = ({
  mission,
  strategies,
  rapports,
  isProvisoire,
  codeSommaire,
  heureEntree,
  date,
  tache_id,
  intervention_id,
  exercicePrecedentData,
  fetchStrategieGlobale,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectItems, setSelectItems] = useState([]);
  const [users, setUsers] = useState([]);
  const [prepared, setPrepared] = useState("");
  const [review, setReview] = useState("");
  const [commentaire, setCommentaire] = useState("");
  const raportsData = [
    "Le rapport au conseil d’administration (Art. 715)",
    "Le rapport général du commissaire aux comptes",
    "Le rapport spécial du commissaire aux comptes",
    "Attestation d’exécution de la mission",
    "Lettre à la direction",
  ];

  /* useEffect(() => {
    const fetchUserMission = async (id) => {
      setLoading(true);
      getListeMembreMission(id)
        .then((res) => {
          if (res) {
            setUsers(res);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchUserMission(mission.id);
  }, [mission]); */

  useEffect(() => {
    const fetchUserMission = async (id) => {
      setLoading(true);

      try {
        const res = await getListeMembreMission(id);

        if (res) {
          let updatedUsers = [...res];

          // Vérifier si revuParRapport existe dans la liste
          const revuParId = parseInt(strategies?.revuParRapport);
          const faitParId = parseInt(strategies?.faitParRapport);

          const revuParExists = res.some((user) => user.id === revuParId);
          const faitParExists = res.some((user) => user.id === faitParId);

          // Si l'un des utilisateurs n'existe pas, chercher dans l'exercice précédent
          if (exercicePrecedentData && (!revuParExists || !faitParExists)) {
            const previousUsers = await getListeMembreMission(
              exercicePrecedentData.id
            );

            if (previousUsers) {
              // Ajouter uniquement l'utilisateur manquant pour revuPar
              if (!revuParExists && revuParId) {
                const missingRevuUser = previousUsers.find(
                  (user) => user.id === revuParId
                );
                if (missingRevuUser) {
                  updatedUsers.push(missingRevuUser);
                }
              }

              // Ajouter uniquement l'utilisateur manquant pour faitPar
              if (!faitParExists && faitParId) {
                const missingFaitUser = previousUsers.find(
                  (user) => user.id === faitParId
                );
                // Éviter les doublons si c'est le même utilisateur
                if (
                  missingFaitUser &&
                  !updatedUsers.some((u) => u.id === missingFaitUser.id)
                ) {
                  updatedUsers.push(missingFaitUser);
                }
              }
            }
          }

          setUsers(updatedUsers);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserMission(mission.id);
  }, [mission, strategies, exercicePrecedentData]);

  useEffect(() => {
    if (strategies) {
      setPrepared(strategies.faitParRapport || "");
      setReview(strategies.revuParRapport || "");
      setCommentaire(strategies.commentaireRapport || "");
    }

    if (rapports && rapports.length > 0) {
      const taches = rapports.map((tache) => ({
        intitule: tache.intitule,
        dateLimiteProd: new Date(tache.dateLimiteProd)
          .toISOString()
          .split("T")[0],
        dateProd: new Date(tache.dateProd).toISOString().split("T")[0],
      }));

      setSelectItems(taches);
    }
  }, [rapports, strategies]);

  const handleAdd = (e) => {
    e.preventDefault();
    const newElement = {
      intitule: "",
      dateLimiteProd: "",
      dateProd: "",
    };

    setSelectItems([...selectItems, newElement]);
  };

  const handleDeleteElement = (index) => {
    const updatedList = selectItems.filter((_, i) => i !== index);
    setSelectItems(updatedList);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      commentaireRapport: commentaire,
      faitParRapport: prepared,
      revuParRapport: review,
      strategie_id: strategies.id,
      codeSommaire,
      isProvisoire: parseInt(isProvisoire) === 1,
      datas: selectItems,
      exercice_id: mission.id,
      client_id: mission.client_id,
      heureEntree,
      date,
      tache_id,
      intervention_id,
    };

    const { status, message } = await ajouterRapportEmettre(data);
    if (status === "success") {
      setLoading(false);
      await swal(succesMessage, "", "success");
      fetchStrategieGlobale();
    } else {
      setLoading(false);
      await swal(message, "", "error");
    }
  };

  const handleImport = async () => {
    const result = await Swal.fire({
      title: '<strong style="font-size: 1.5em;">Êtes vous sûr ?</strong>',
      html: "Voulez-vous importer les données de l'exercice précédent ? Les données actuelles seront remplacées.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d1ec51",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Annuler",
    });

    if (!result.isConfirmed) return;

    setLoading(true);
    try {
      const res = await getStrategieGlobaleMission(exercicePrecedentData.id);
      const strategie = (res.result || []).find(
        (item) => item.isProvisoire === (parseInt(isProvisoire) === 1)
      );

      if (strategie) {
        // Importer les données "Action sur le dossier"
        setPrepared(strategie.faitParRapport || "");
        setReview(strategie.revuParRapport || "");
        setCommentaire(strategie.commentaireRapport || "");

        // Importer les rapports
        if (
          strategie.Lea_StrategieRapports &&
          strategie.Lea_StrategieRapports.length > 0
        ) {
          const taches = strategie.Lea_StrategieRapports.map((tache) => ({
            intitule: tache.intitule,
            dateLimiteProd: new Date(tache.dateLimiteProd)
              .toISOString()
              .split("T")[0],
            dateProd: new Date(tache.dateProd).toISOString().split("T")[0],
          }));

          setSelectItems(taches);
        } else {
          setSelectItems([]);
        }

        // Charger les utilisateurs de l'exercice précédent
        try {
          const previousUsers = await getListeMembreMission(
            exercicePrecedentData.id
          );

          if (previousUsers) {
            // Fusionner les utilisateurs actuels et précédents sans doublons
            const currentUsers = await getListeMembreMission(mission.id);
            const allUsers = currentUsers ? [...currentUsers] : [];

            // Ajouter les utilisateurs précédents qui ne sont pas déjà dans la liste
            previousUsers.forEach((prevUser) => {
              if (!allUsers.some((u) => u.id === prevUser.id)) {
                allUsers.push(prevUser);
              }
            });

            setUsers(allUsers);
          }
        } catch (error) {
          console.error("Erreur lors du chargement des utilisateurs:", error);
        }

        await swal({
          title: "Importation effectuée avec succès",
          text: "Les données ont été importées. Pensez à enregistrer.",
          icon: "success",
        });
      } else {
        setPrepared("");
        setReview("");
        setCommentaire("");
        setSelectItems([]);
        await swal(
          "Aucune stratégie trouvée pour cet exercice précédent.",
          "",
          "error"
        );
      }
    } catch (error) {
      console.error("Erreur lors de l'importation:", error);
      await swal("Erreur lors de l'importation", "", "error");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: () => <TableTitle>Intitulé rapport</TableTitle>,
      dataIndex: "intitule",
      key: "index",
      render: (_, record, index) => (
        <select
          style={{ fontSize: "14px" }}
          name="action"
          className="form-select"
          onChange={(e) => {
            const updatedList = selectItems.map((item, i) =>
              i === index ? { ...item, intitule: e.target.value } : item
            );

            setSelectItems(updatedList);
          }}
          value={record.intitule}
        >
          <option>Sélectionner une action...</option>
          {raportsData.map((opt, index) => (
            <option key={index} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ),
    },
    {
      title: () => <TableTitle>Date limite de production</TableTitle>,
      dataIndex: "dateLimiteProd",
      key: "dateLimiteProd",
      width: 200,
      render: (_, record, index) => (
        <input
          type="date"
          className="form-control mb-2"
          placeholder="Date"
          onChange={(e) => {
            const updatedList = selectItems.map((item, i) =>
              i === index ? { ...item, dateLimiteProd: e.target.value } : item
            );

            setSelectItems(updatedList);
          }}
          value={record.dateLimiteProd}
        />
      ),
    },
    {
      title: () => <TableTitle>Date de production</TableTitle>,
      dataIndex: "dateProd",
      key: "dateProd",
      width: 200,
      render: (_, record, index) => (
        <input
          type="date"
          className="form-control mb-2"
          placeholder="Date"
          onChange={(e) => {
            const updatedList = selectItems.map((item, i) =>
              i === index ? { ...item, dateProd: e.target.value } : item
            );

            setSelectItems(updatedList);
          }}
          value={record.dateProd}
        />
      ),
    },
    {
      title: () => <TableTitle>Action</TableTitle>,
      dataIndex: "action",
      width: 70,
      render: (_, record, index) => (
        <>
          <Button
            onClick={() => handleDeleteElement(index)}
            title="Supprimer ?"
            type="primary"
            icon={<DeleteOutlined />}
            danger
          />
        </>
      ),
    },
  ];

  return (
    <div className="card d-flex flex-column fv-plugins-bootstrap5 fv-plugins-framework p-5">
      {
        <div className="d-flex justify-content-end align-items-end mb-10 gap-2">
          {exercicePrecedentData && !selectItems.length && (
            <Tooltip title="Importer les données de l'année précédente">
              <Button
                disabled={
                  mission.isCloture === 1 || mission.isClotureProvisoire === 1
                }
                loading={loading}
                size={"large"}
                style={{
                  backgroundColor: appTheme.colors.primary,
                  color: "white",
                }}
                icon={
                  <FontAwesomeIcon
                    style={{ paddingRight: "10" }}
                    icon={faFileImport}
                  />
                }
                onClick={handleImport}
              >
                {!loading && (
                  <span className="indicator-label text-white">Importer</span>
                )}
                {loading && (
                  <span className="indicator-progress text-white">
                    Importation en cours...
                  </span>
                )}
              </Button>
            </Tooltip>
          )}
          <Tooltip title="Enregistrer">
            <Button
              disabled={
                mission.isCloture === 1 || mission.isClotureProvisoire === 1
              }
              size={"large"}
              loading={loading}
              style={{
                backgroundColor: appTheme.colors.secondary,
                color: "white",
              }}
              icon={
                <FontAwesomeIcon style={{ paddingRight: "10" }} icon={faSave} />
              }
              onClick={handleSubmit}
            >
              {!loading && (
                <span className="indicator-label text-white">Enregistrer</span>
              )}
              {loading && (
                <span className="indicator-progress text-white">
                  Patientez svp...
                </span>
              )}
            </Button>
          </Tooltip>
        </div>
      }
      <div className="card-header">
        <div className="card-title">
          <Title
            style={{
              display: "block",
              fontWeight: "600",
              color: appTheme.colors.primary,
              // textAlign: "center"
            }}
            level={4}
          >
            {"EC4.9: Rapports à émettre"}
          </Title>
        </div>
      </div>
      <div className="">
        <div className="d-flex flex-column me-5">
          <div className="d-flex text-gray-700 fw-bold fs-7 mt-2">
            <button onClick={handleAdd} className="btn btn-sm fs-5 btn-primary">
              Ajouter un champ
            </button>
          </div>
        </div>
        <div className="table-responsive my-5">
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={selectItems}
            loading={loading}
            scroll={{
              y: 800,
            }}
            size={"small"}
            rowSelection
            pagination={false}
          />
        </div>
        {/*<div className='mt-7'>*/}
        {/*    <textarea*/}
        {/*        className='form-control mb-2'*/}
        {/*        rows="50"*/}
        {/*        cols="150"*/}
        {/*        maxLength={1000}*/}
        {/*        style={{*/}
        {/*            height: '150px',*/}
        {/*            marginBottom: 24,*/}
        {/*        }}*/}
        {/*        placeholder="Votre texte ici..."*/}
        {/*        onChange={(e) => {*/}
        {/*            setCommentaire(e.target.value)*/}
        {/*        }}*/}
        {/*        value={commentaire}*/}
        {/*    >*/}
        {/*    </textarea>*/}
        {/*    <div className="text-muted fs-7">.</div>*/}
        {/*</div>*/}
        <div className="w-100">
          <div className="card-title mb-2">
            <Title
              style={{
                fontSize: "24px",
                display: "block",
                fontWeight: "600",
                color: appTheme.colors.primary,
              }}
              level={5}
            >
              # Action sur le dossier :
            </Title>
          </div>

          <div className="d-flex">
            <div className="col-lg-1">
              <FontAwesomeIcon
                icon={faUserCircle}
                size={"3x"}
                color={appTheme.colors.primary_blue}
              />
            </div>
            <div className="col-lg-6">
              <Space.Compact block>
                <Input
                  size="large"
                  style={{
                    width: "30%",
                    fontWeight: "400",
                  }}
                  value="Préparer par: "
                  readOnly={true}
                />
                {mission.isCloture === 1 ||
                mission.isClotureProvisoire === 1 ? (
                  <Input
                    size="large"
                    style={{
                      width: "70%",
                      fontWeight: "700",
                      textTransform: "uppercase",
                    }}
                    value={`${
                      users?.find((user) => user.id === parseInt(prepared))
                        ?.initial || ""
                    } - ${
                      users?.find((user) => user.id === parseInt(prepared))
                        ?.nom_user || ""
                    } ${
                      users?.find((user) => user.id === parseInt(prepared))
                        ?.prenom_user || ""
                    }`}
                    readOnly={true}
                  />
                ) : (
                  <Select
                    showSearch
                    placeholder="Sélectionnez l'utilisateur..."
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      String(option?.children || "")
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={prepared ? parseInt(prepared) : undefined}
                    disabled={
                      mission.isCloture === 1 ||
                      mission.isClotureProvisoire === 1
                    }
                    onChange={(value) => setPrepared(value)}
                    size="large"
                    style={{ width: "70%" }}
                  >
                    {users?.map((user) => (
                      <Select.Option key={user.id} value={user.id}>
                        <span className="fw-boldest fs-5 text-uppercase">{`${
                          user.initial || ""
                        } - ${user.nom_user || ""} ${
                          user.prenom_user || ""
                        }`}</span>
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Space.Compact>
            </div>
          </div>
          <br />
          <br />
          <div className="d-flex">
            <div className="col-lg-1">
              <FontAwesomeIcon
                icon={faUserCircle}
                size={"3x"}
                color={appTheme.colors.primary_blue}
              />
            </div>
            <div className="col-lg-6">
              <Space.Compact block>
                <Input
                  size="large"
                  style={{
                    width: "30%",
                    fontWeight: "400",
                  }}
                  value="Revu par"
                  readOnly={true}
                />
                {mission.isCloture === 1 ||
                mission.isClotureProvisoire === 1 ? (
                  <Input
                    size="large"
                    style={{
                      width: "70%",
                      fontWeight: "700",
                      textTransform: "uppercase",
                    }}
                    value={`${
                      users?.find((user) => user.id === parseInt(review))
                        ?.initial || ""
                    } - ${
                      users?.find((user) => user.id === parseInt(review))
                        ?.nom_user || ""
                    } ${
                      users?.find((user) => user.id === parseInt(review))
                        ?.prenom_user || ""
                    }`}
                    readOnly={true}
                  />
                ) : (
                  <Select
                    showSearch
                    placeholder="Sélectionnez le second utilisateur..."
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      String(option?.children || "")
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    value={review ? parseInt(review) : undefined}
                    disabled={
                      mission.isCloture === 1 ||
                      mission.isClotureProvisoire === 1
                    }
                    onChange={(value) => setReview(value)}
                    size="large"
                    style={{ width: "70%" }}
                  >
                    {users?.map((user) => (
                      <Select.Option key={user.id} value={user.id}>
                        <span className="fw-boldest fs-5 text-uppercase">{`${
                          user.initial || ""
                        } - ${user.nom_user || ""} ${
                          user.prenom_user || ""
                        }`}</span>
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Space.Compact>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Rapport };
